import React, { useState, useRef, useEffect } from 'react';

const FilterDropdown = ({ label, options, value, onChange, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle option selection
  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Find the selected option label
  const selectedOption = options.find(option => option.value === value);
  const displayLabel = selectedOption ? selectedOption.label : label;

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-[6px] px-[15px] py-[8px] bg-[#F5F5F5] rounded-[16px] hover:bg-gray-100 focus:outline-none ${className || ''}`}
      >
        <span>{displayLabel}</span>
        {label === 'Sort' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M4.81836 3.81213L7.94336 6.93713L11.0684 3.81213" stroke="#1C1C1C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.81836 8.18713L7.94336 11.3121L11.0684 8.18713" stroke="#1C1C1C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
        {label === 'Filter' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2.76172 3.81213H14.0117" stroke="#1C1C1C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5.26172 7.56213H11.5117" stroke="#1C1C1C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7.13672 11.3121H9.63672" stroke="#1C1C1C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
        {label === 'Type' && (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_63_24146)">
          <path d="M7.13649 12.5621C7.13644 12.6783 7.16875 12.7921 7.2298 12.8909C7.29085 12.9898 7.37822 13.0696 7.48212 13.1215L8.73212 13.7465C8.82743 13.7941 8.93333 13.8166 9.03977 13.8118C9.14621 13.807 9.24965 13.775 9.34026 13.719C9.43088 13.6629 9.50566 13.5846 9.55751 13.4916C9.60935 13.3985 9.63654 13.2937 9.63649 13.1871V8.81213C9.63663 8.50237 9.75178 8.2037 9.95962 7.97401L14.474 2.98088C14.5549 2.89123 14.6081 2.78006 14.6272 2.66081C14.6462 2.54156 14.6304 2.41934 14.5814 2.30893C14.5325 2.19852 14.4526 2.10465 14.3515 2.03867C14.2504 1.97268 14.1323 1.93742 14.0115 1.93713H2.76149C2.64062 1.93718 2.52236 1.97227 2.42102 2.03816C2.31969 2.10404 2.23964 2.1979 2.19056 2.30836C2.14148 2.41882 2.12548 2.54114 2.14451 2.6605C2.16353 2.77987 2.21676 2.89115 2.29774 2.98088L6.81337 7.97401C7.0212 8.2037 7.13635 8.50237 7.13649 8.81213V12.5621Z" stroke="#1C1C1C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          </g>
          <defs>
          <clipPath id="clip0_63_24146">
          <rect width="15" height="15" fill="white" transform="translate(0.886719 0.0621338)"/>
          </clipPath>
          </defs>
          </svg>
        )}
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20">
          <div className="py-1">
            {options.map((option) => (
              <button
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`block w-full text-left px-4 py-2 text-sm ${
                  value === option.value
                    ? 'bg-green-100 text-green-800'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
